const State = {
  ACTIVE: 0,
  DONE: 1,
  TODO: 2,
  ERROR: 3,
};

export default State;
